/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { useCallback, useMemo, useState } from 'react'
// import Select from 'react-select'
// import makeAnimated from 'react-select/animated'

import Icon from '../../../components/Icon'
import { Flex } from '../../../components/Layout'
import SuspensionInput from '../../../components/Suspensions/SuspensionInput'
import SuspensionSelect from '../../../components/Suspensions/SuspensionSelect'
import SuspensionSubmitButton from '../../../components/Suspensions/SuspensionSubmitButton'
import SearchContainer from '../../Search/SearchContainer'
import { RegistrationSettingsTitle } from '../EditRegistration'
import ToolbarButton from '../Registration/Division/ToolbarButton'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from '../../../state'
import CurrencyInput from '../../../components/CurrencyInput'
import ToggleSection from '../EditRegistration/ToggleSection'

const installmentsOptions = [
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9 },
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 },
]

const InnerDivisionSettings = observer(
  ({ onClose, divisionId, divisionName }) => {
    const {
      registrationTypes: {
        state: { age_range_type, gender_type, day_of_week_type, currency_type },
      },
      registration: {
        createRegistration,
        updateDivision,
        state: { divisions },
      },
    } = useMobxStore()

    const currentDivision = useMemo(() => {
      return divisions.find((division) => division.id === divisionId)
    }, [divisionId])

    const [maxTeams, setMaxTeams] = useState(
      currentDivision?.registration?.max_teams ?? 0
    )
    const [maxPlayers, setMaxPlayers] = useState(
      currentDivision?.registration?.max_players_per_team ?? 0
    )
    const [costPerReg, setCostPerReg] = useState(
      currentDivision?.registration?.team_cost ?? 0
    )
    const [deposit, setDeposit] = useState(
      currentDivision?.registration?.deposit ?? 0
    )

    const [dayOfWeek, setDayOfWeek] = useState(
      Number(currentDivision?.registration?.day_of_week?.id) ?? 1
    )
    const [gender, setGender] = useState(
      Number(currentDivision?.registration?.division_gender?.id) ?? 1
    )
    const [currency, setCurrency] = useState(
      Number(currentDivision?.registration?.currency?.id) ?? 1
    )
    const [age, setAge] = useState(
      Number(currentDivision?.registration?.division_age?.id) ?? 1
    )
    const [installments, setInstallments] = useState(
      currentDivision?.registration?.installments ?? 1
    )
    const [forcePayment, setForcePayment] = useState(
      currentDivision?.registration?.deposit_required ?? false
    )

    const handleSubmit = useCallback(() => {
      const body = {
        currency: currency || 1,
        day_of_week: dayOfWeek || 1,
        division_gender: gender || 1,
        max_teams: maxTeams || 0,
        deposit: deposit,
        team_cost: costPerReg,
        division_age: age || 1,
        max_players_per_team: maxPlayers,
        max_team_rep_per_team: 1,
        installments: installments,
        deposit_required: forcePayment,
      }

      if (currentDivision?.registration?.id) {
        updateDivision({
          scheduleId: divisionId,
          info: body,
        })
      } else {
        createRegistration({
          level: 'division',
          scheduleId: divisionId,
          info: body,
        })
      }
    }, [
      age,
      currency,
      dayOfWeek,
      gender,
      maxTeams,
      deposit,
      costPerReg,
      maxPlayers,
      installments,
      forcePayment,
    ])

    return (
      <div
        css={css`
          margin-top: 16px;

          .add-report-row {
            margin-bottom: 16px;

            &:not(:last-of-type) {
              margin-right: 16px;
            }
          }

          .suspension-select-container {
            max-width: unset;
            &:last-of-type {
              padding-right: 0;
            }
          }
        `}
      >
        <RegistrationSettingsTitle>Division Settings</RegistrationSettingsTitle>

        <Flex>
          <SuspensionInput
            height={40}
            label='Division Name'
            id='name'
            disabled
            type='text'
            value={divisionName}
            required
          />
        </Flex>

        <Flex>
          <SuspensionSelect
            useFullWidth
            enabledAllItemsOption={false}
            required
            label='Day of Week'
            placeholder='-'
            value={dayOfWeek}
            onChange={(e) => setDayOfWeek(e)}
            options={day_of_week_type.map((el) => ({
              text: el.name,
              value: Number(el.id),
            }))}
          />
          <div
            css={css`
              margin: 0 8px;
            `}
          />
          <SuspensionSelect
            enabledAllItemsOption={false}
            required
            useFullWidth
            label='Division Gender'
            placeholder='-'
            value={gender}
            onChange={(e) => setGender(e)}
            options={gender_type.map((el) => ({
              text: el.name,
              value: Number(el.id),
            }))}
          />
        </Flex>

        <Flex noFlex>
          <div
            css={css`
              width: 100%;
            `}
          >
            <SuspensionSelect
              enabledAllItemsOption={false}
              required
              useFullWidth
              label='Age Range'
              placeholder='-'
              value={age}
              onChange={(e) => setAge(e)}
              options={age_range_type.map((el) => ({
                text: el.name,
                value: Number(el.id),
              }))}
            />
          </div>
        </Flex>

        <Flex noFlex>
          <SuspensionInput
            height={40}
            label='Max Players per Team'
            type='number'
            min={0}
            step={1}
            value={maxPlayers}
            onChange={({ target }) => setMaxPlayers(target.value)}
            required
          />
          <SuspensionInput
            height={40}
            label='Max Number of Teams'
            id='team_slots'
            type='number'
            min={0}
            step={1}
            value={maxTeams}
            onChange={({ target }) => setMaxTeams(target.value)}
          />
        </Flex>
        <Flex>
          <SuspensionSelect
            enabledAllItemsOption={false}
            required
            useFullWidth
            label='Currency'
            placeholder='-'
            value={currency}
            onChange={(e) => setCurrency(e)}
            options={currency_type.map((el) => ({
              text: el.name,
              value: Number(el.id),
            }))}
          />
          <div
            css={css`
              margin: 0 8px;
            `}
          />
          <CurrencyInput
            placeholder={0.0}
            type='text'
            onChange={({ target }) =>
              setDeposit(target.value?.replace(/[^0-9.]/g, ''))
            }
            value={deposit}
            label='Deposit'
            required
          />
          <div
            css={css`
              margin: 0 8px;
            `}
          />
          <CurrencyInput
            placeholder={0.0}
            type='text'
            onChange={({ target }) =>
              setCostPerReg(target.value?.replace(/[^0-9.]/g, ''))
            }
            value={costPerReg}
            label='Cost per Registration'
            required
          />
        </Flex>

        <Flex noFlex>
          <div
            css={css`
              width: 100%;
              margin-bottom: 16px;
            `}
          >
            <ToggleSection
              title='Required Deposit'
              description='When turned ON, users will only complete the registration after paying the deposit.'
              isEnabled={forcePayment}
              onClick={() => setForcePayment(!forcePayment)}
            />
          </div>
        </Flex>

        <Flex noFlex>
          <div
            css={css`
              width: 100%;
            `}
          >
            <SuspensionSelect
              enabledAllItemsOption={false}
              required
              useFullWidth
              label='Number of Installments'
              placeholder='-'
              value={installments}
              onChange={(e) => setInstallments(e)}
              options={installmentsOptions}
            />
          </div>
        </Flex>
        <Flex
          alignItems='center'
          justifyContent='center'
          css={css`
            margin-top: 64px;
          `}
        >
          <SuspensionSubmitButton onClick={onClose}>
            Cancel
          </SuspensionSubmitButton>
          <SuspensionSubmitButton
            onClick={handleSubmit}
            isSolid
            css={css`
              margin-left: 40px;
            `}
          >
            Confirm
          </SuspensionSubmitButton>
        </Flex>
      </div>
    )
  }
)

const DivisionSettings = ({ divisionId, divisionName }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ToolbarButton
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <Icon name='cog' color={colors.DEFAULT_FLAIR} fontSize={19} />
      </ToolbarButton>

      <div
        css={css`
          .search-container {
            z-index: 1000;
          }
        `}
      >
        <SearchContainer displayContents={isOpen} isTeamOrSchedulePage>
          {isOpen && (
            <Flex
              noFlex
              alignItems='center'
              justifyContent='space-around'
              css={css`
                width: 100%;
              `}
            >
              <InnerDivisionSettings
                divisionId={divisionId}
                divisionName={divisionName}
                onClose={() => {
                  setIsOpen(false)
                }}
              />
            </Flex>
          )}
        </SearchContainer>
      </div>
    </>
  )
}

export default DivisionSettings

/* THE SKILL LEVEL INPUT */
/* <div
  css={css`
    margin-bottom: 16px;
  `}
>
  <p
    css={css`
      min-height: 12px;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 8px;
    `}
  >
    Skill Levels *
  </p>
  <Select
    options={[
      { value: 'aaa', label: 'AAA' },
      { value: 'aa', label: 'AA' },
      { value: 'a', label: 'A' },
      { value: 'b', label: 'B' },
      { value: 'ae_md', label: 'AE/MD' },
      { value: 'house_select', label: 'House Select' },
      { value: 'house_rec', label: 'House/Rec' },
      { value: 'hs_varsity', label: 'HS Varsity' },
      { value: 'hs_jv', label: 'HS JV' },
      { value: 'girls_tier_1', label: 'Girls Tier 1' },
      { value: 'girls_tier_2', label: 'Girls Tier 2' },
      { value: 'girls_rec', label: 'Girls Rec' },
    ]}
    closeMenuOnSelect={false}
    components={animatedComponents}
    defaultValue={[]}
    onChange={(value) => setSkillLevels(value)}
    isMulti
    styles={{
      container: (baseStyles) => ({
        ...baseStyles,
        width: '100%',
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: colors.HEADER,
        borderColor: colors.SOFT_STEEL,
        minHeight: 40,
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: colors.HEADER,
        borderColor: colors.SOFT_STEEL,
        zIndex: 9999,
      }),
      option: (baseStyles, { isFocused }) => ({
        ...baseStyles,
        backgroundColor: isFocused ? 'rgba(0, 0, 0, 0.9)' : undefined,
      }),
      multiValue: (baseStyles) => {
        return {
          ...baseStyles,
          backgroundColor: colors.DEFAULT_FLAIR,
          height: 32,
          alignItems: 'center',
        }
      },
      multiValueLabel: (baseStyles) => ({
        ...baseStyles,
        color: colors.BLACK,
      }),
      multiValueRemove: (baseStyles) => ({
        ...baseStyles,
        color: colors.BLACK,
        height: 32,
        ':hover': {
          backgroundColor: colors.BLACK,
          color: colors.DEFAULT_FLAIR,
        },
      }),
    }}
  />
</div> */
